var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBbl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    enableBackground: "new 0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M86.8,29.8L64,0L41.2,29.8c-17.2,22.5-24,32.6-24,47.7c0,12.8,3.3,19,15.3,27.7L64,128l31.5-22.8 c12-8.7,15.3-14.9,15.3-27.7C110.8,62.4,104,52.3,86.8,29.8z M57,103.8l-0.2,6.2c0,0.8-0.5,0.9-1,0.5C47.6,104.6,38,97.6,38,97.6 c-10-7.2-10.6-15-10.6-20.3c0-3.6,0.5-7.5,2.2-11.5c0.1-0.3,0.3-0.8,0.6-0.8c0.2,0,0.3,0.1,0.4,0.3c3.5,5.1,9.1,13.4,14.7,20.2 C56.1,98.5,57.2,97.4,57,103.8z M64,92.1c-0.1,0-0.2-0.1-0.3-0.1L41.6,65.8c-2.5-3-3.9-6.3-3.9-9.6c0-2.2,0.8-4.5,2.4-6.6l23.6-32.4 c0.1-0.1,0.2-0.2,0.3-0.2c0.1,0,0.2,0.1,0.3,0.2l23.6,32.4c1.5,2.1,2.4,4.4,2.4,6.6c0,3.3-1.3,6.6-3.9,9.6L64.3,92 C64.2,92.1,64.1,92.1,64,92.1z M90,97.6c0,0-9.7,7-17.8,12.9c-0.5,0.4-0.9,0.3-1-0.5l-0.2-6.2c-0.2-6.4,0.9-5.3,11.7-18.3 c5.6-6.8,11.2-15,14.7-20.2c0.1-0.2,0.3-0.3,0.4-0.3c0.2,0,0.5,0.5,0.6,0.8c1.6,4,2.2,7.9,2.2,11.5C100.6,82.6,100,90.4,90,97.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBbl);
export default __webpack_public_path__ + "static/media/bbl.88f3b91e0b3b2c6227961965ebdbb3a3.svg";
export { ForwardRef as ReactComponent };